import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type LifeEventDto, type LifeEventUpdateDto, updateLifeEvent } from '../../generated/client';
import { queryKeys } from '../../query-keys';

interface IUpdateLifeEventParams {
    eventId: number;
    event: LifeEventUpdateDto;
}

export const useUpdateLifeEvent = (): UseMutationResult<LifeEventDto, AxiosError, IUpdateLifeEventParams> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: ({ eventId, event }) => updateLifeEvent({ path: { lifeEventId: eventId }, body: event }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.events(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.notifications() });
            queryClient.invalidateQueries({ queryKey: queryKeys.notificationsForClient(client?.id) });
        },
    });
};
